import { TOXICS_HIGH_RISK_SCORE } from './constants';

/**
 * filters scores with high risk or very high risk assessment
 * and sorts them by score descending
 *
 * @param {Object[]} scores - scores
 * @param {number} scores[].score - score
 *
 * @returns {Object[]} - scores with risks
 */
export function filterScoresByRisks(scores) {
    return scores.sort((a, b) => b.score - a.score)
        .filter(({ score }) => score >= TOXICS_HIGH_RISK_SCORE);
}
